export const getAmountUnitSuffix = (divisor) => {
  const div = Number(divisor) || 1;
  if (div === 1000) return "K";
  if (div === 100000) return "L";
  if (div === 10000000) return "Cr";
  return "";
};

export const formatIndianNumber = (number, style = "indian") => {
  const num = parseFloat(number).toFixed(2);

  if (style === "indian" || style === "india") {
    return num.replace(/\B(?=(\d{3})(\d{2})*(?!\d))/g, ",");
  }

  return num.replace(/\B(?=(\d{3})+(?!\d))/g, ",");
};

export const formatDashboardAmount = (rawNumber, divisor = 1, style = "indian") => {
  const div = Number(divisor) || 1;
  const suffix = getAmountUnitSuffix(div);
  const scaled = Number(rawNumber || 0) / div;
  const formatted = formatIndianNumber(scaled, style);
  return suffix ? `${formatted}${suffix}` : formatted;
};

export const createDashboardFormatter = (divisor) => (rawNumber, style = "indian") =>
  formatDashboardAmount(rawNumber, divisor, style);
